






























































































































































import { mapGetters, mapState } from 'vuex'
import COrientationMixin from '~/components/shared/configurable/mixin/COrientationMixin.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import { SET_AVATAR } from '~/store/modules/shared/user/mutation-types'
import { ciCamera } from '~/icons/source/regular/camera'
import CImageCropperModal from '~/components/shared/configurable/user/avatar/CImageCropperModal.vue'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { defineComponent } from '~/utils/nuxt3-migration'
import { ciCheck } from '~/icons/source/solid/check'
import { ciTimes } from '~/icons/source/solid/times'

export default defineComponent({
  components: { CConfirmationModal, CImageCropperModal },
  mixins: [COrientationMixin],
  props: {
    wh: {
      // this is the width and height in pixels of the whole component element,
      // you can set it from mako using wh="500" if you want it to be 500x500px (only square dimensions support for now)
      type: Number,
      default: 100,
      required: false
    },
    // if "editable" does not exists in mako declaration, then the user can't upload image
    // all the elements of the uploader (like the progress circle bar, and the camera icon) are removed
    editable: {
      type: Boolean,
      default: false,
      required: false
    },
    // if "showInitials" the the avatar would show the initials of the user (if there is no avatar uploaded),
    // good for guests - needs username
    showInitials: {
      type: Boolean,
      default: false,
      required: false
    },
    userId: {
      type: Number,
      required: false,
      default: null
    },
    maxFileSize: { type: Number, default: 3 }, // in MB
    maxResizeWidth: { type: Number, default: 99999999 },
    maxResizeHeight: { type: Number, default: 1024 },
    minHeight: { type: Number, default: 500 },
    minWidth: { type: Number, default: 500 },
    canDelete: { type: Boolean, required: false, default: true },
    inIframe: { type: Boolean, required: false, default: false },
    useCropperModal: { type: Boolean, required: false, default: false },
    acceptedFiles: {
      type: Array,
      default: () => [
        'image/jpeg',
        'image/jpg',
        'image/gif',
        'image/png',
        'image/heic',
        'image/heif',
        '.heic',
        '.heif'
      ]
    }
  },
  data() {
    return {
      icons: {
        camera: ciCamera,
        check: ciCheck,
        times: ciTimes
      },
      uploadPercentage: 0,
      progressStarted: false,
      progressClass: 'uploading',
      cssProgressLeft: '',
      cssProgressRight: '',
      cssAvatarHeight: '',
      cssAvatarWidth: '',
      avatarVertical: false,
      avatar: this.loadedAvatar || null,
      showDelete: false,
      cropperModalFile: null,
      showCropperModal: false,
      deleteAvatarModalVisible: false
    }
  },
  computed: {
    ...mapState(USER_NS, {
      loggedUserAvatar: 'avatar',
      loggedUserId: 'id',
      username: 'username'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc'
    }),
    acceptedFilesString() {
      let str = ''
      for (let i = 0; i < this.acceptedFiles.length; i++) {
        str += this.acceptedFiles[i]
        if (i + 1 < this.acceptedFiles.length) {
          str += ','
        }
      }

      return str
    },
    defaultAvatar() {
      return require('~/assets/img/user/default_profile.png')
    },
    hasNoAvatar() {
      return this.avatar === this.defaultAvatar
    },
    loadedAvatar() {
      if (this.loggedUserId !== this.userId) {
        return null
      }

      return this.loggedUserAvatar
    },
    selectedUsedId() {
      if (this.userId && this.userId !== this.loggedUserId) {
        // we are probably setting a store's avatar
        return this.userId
      }

      return this.loggedUserId
    },
    initials() {
      const names = this.userName
        .replace(/[&/\\#,+\-()!$~%.'":*?<>{}]/g, '')
        .trim()
        .replace(/ +/g, ' ')
        .split(' ')
      let initials = names[0].substring(0, 1).toUpperCase()

      for (let i = 0; i < names.length; i++) {}

      if (names.length > 1) {
        initials += names[1].substring(0, 1).toUpperCase()
      }

      return initials.trim()
    },
    requestUrl() {
      return `/api/${this.selectedUsedId}/files/avatar/`
    }
  },
  mounted() {
    if (this.loadedAvatar === null) {
      this.fetch()
    } else {
      this.avatar = this.safeLoadAvatar(this.loadedAvatar)
      this.showDelete = true
    }
  },
  methods: {
    onHide() {
      this.cropperModalFile = null
      this.$refs.fileInput.value = ''
    },
    safeLoadAvatar(src) {
      const image = new Image()

      image.onload = () => {
        this.avatar = src
      }
      image.onerror = () => {
        this.avatar = this.defaultAvatar
      }
      image.src = src
    },
    fetch() {
      this.$axios
        .get(this.requestUrl)
        .then(response => {
          if (response.status === 200 && response.data.data.avatar) {
            this.avatar = this.safeLoadAvatar(response.data.data.avatar)
            this.showDelete = true
          } else {
            this.avatar = this.defaultAvatar
            this.showDelete = false
          }
        })
        .catch(error => {
          this.avatar = this.defaultAvatar
          this.showDelete = false
          this.$logger.captureError(error)
        })
    },
    triggerFileInput() {
      this.$refs.fileInput.value = ''
      this.$refs.fileInput.click()
    },
    onFileChange(e) {
      let currentFiles

      if (e.dataTransfer) {
        currentFiles = e.dataTransfer.files
      } else if (e.target) {
        currentFiles = e.target.files
      }

      if (currentFiles === null || !currentFiles.length) {
        return
      }

      const file = this.createFileFromInput(currentFiles[0])

      if (!this.inIframe) {
        this.showCropperModal = true
      }

      this.readFile(file, currentFiles.length)

      // this.submitImage(currentFiles[0])
    },
    createFileFromInput(currentFile) {
      return {
        file: currentFile,
        originalFilename: currentFile.name,
        filename: currentFile.name,
        uploading: false,
        percentage: 0,
        thumb: null,
        error: null,
        approved: false,
        type: null,
        deleted: false,
        warning: ''
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    realAddFile(origFile, currentFilesLength) {
      if (this.useCropperModal && this.isCanvasSupported && !this.inIframe) {
        this.cropperModalFile = origFile
      } else {
        this.submitImage(origFile)
      }
    },
    submitImage(origFile) {
      // reset variables in case this is the second time we upload
      this.progressClass = 'uploading'
      this.cssProgressLeft = ''
      this.cssProgressRight = ''
      this.progressStarted = true
      this.avatarVertical = false
      this.showDelete = false

      const file = origFile.file

      if (file.size / 1024000 < 3) {
        // if file is smaller that 3MB then submit, else error
        const reader = new FileReader()

        reader.onload = e => {
          this.avatar = e.target.result
        }

        reader.readAsDataURL(file)

        const formData = new FormData()
        formData.append('file', file)

        this.$axios
          .post(this.requestUrl, formData, {
            onUploadProgress: progressEvent => {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              )

              if (this.uploadPercentage <= 50) {
                this.cssProgressLeft =
                  'rotate(' + this.uploadPercentage * 3.6 + 'deg)'
              } else {
                this.cssProgressLeft = 'rotate(180deg)'
                this.cssProgressRight =
                  'rotate(' + (this.uploadPercentage * 3.6 - 180) + 'deg)'
              }
            }
          })
          .then(() => {
            this.progressClass = 'uploadSuccess'
            if (this.selectedUsedId === this.loggedUserId) {
              this.$store.commit(`${USER_NS}/${SET_AVATAR}`, this.avatar)
            }
            this.showDelete = true
          })
          .catch(error => {
            this.$logger.captureError(error)
            this.progressClass = 'uploadError'
            this.errorAlert(this.$t('an error occurred please try again later'))
          })
      } else {
        this.progressClass = 'uploadError'
        this.errorAlert(
          this.$t('file size cannot exceed') + ' ' + this.maxFileSize + 'MB'
        )
      }
    },
    showConfirmDialog() {
      if (this.inIframe) {
        if (confirm(this.$t('this action will delete your profile picture'))) {
          this.deleteAvatar()
        }
      } else {
        this.deleteAvatarModalVisible = true
      }
    },
    deleteAvatar() {
      this.$axios
        .delete(this.requestUrl)
        .then(() => {
          this.progressStarted = false
          this.avatar = this.defaultAvatar
          this.showDelete = false
          this.$store.commit(`${USER_NS}/${SET_AVATAR}`, null)
        })
        .catch(() => {
          this.errorAlert(this.$t('an error occurred please try again later'))
        })
    },
    errorAlert(message: string) {
      if (this.inIframe) {
        alert(message)
      } else {
        this.$snackbar.error(message)
      }
    },
    centerAvatarImg() {
      // USED ONLY WHEN THE AVATAR HAS POSITION ABSOLUTE (ghost method for now)
      // this method centers the image depending on whether it's horizontal or vertical
      // it's done this way (with Image()) because none of the usual ways worked for calculating
      // the image's width/height (because the parent has overflow: hidden)
      // so what I do is, I load the original image into a new Image object and I calculate the original width/height
      // then I scale it down to fit the 100px/100px aspect ratio
      // in order for the image to be centered, I apply a dynamically calculated negative margin

      const i = new Image()
      const vm = this
      i.onload = function() {
        const actualWidth = i.width
        const actualHeight = i.height

        const aspectWidth = (actualWidth / actualHeight) * vm.wh
        const aspectHeight = (actualHeight / actualWidth) * vm.wh

        if (actualWidth >= actualHeight) {
          vm.cssAvatarWidth = '-' + (aspectWidth - vm.wh) / 2 + 'px'
          vm.cssAvatarHeight = ''
        } else {
          vm.cssAvatarWidth = ''
          // actualHeight = $("#theAvatar")[0].scrollHeight;
          vm.cssAvatarHeight = '-' + (aspectHeight - vm.wh) / 2 + 'px'
          vm.avatarVertical = true
        }
      }

      i.src = this.avatar
    }
  }
})
